import { ASSETS } from '../assets';
import { Company } from '../types/company';

export const EXPERIENCES: Company[] = [
  {
    name: 'Alrajhi Capital',
    id: 'arc',
    icon: ASSETS.images.arc_logo,
    h: 35,
    w: 100,
  },
  {
    name: 'Ejada',
    id: 'ejada',
    icon: ASSETS.images.ejada,
    h: 45,
    w: 100,
  },
  {
    name: 'Etisalat Egypt',
    id: 'etistal',
    icon: ASSETS.images.etisalat,
    h: 45,
    w: 45,
  },
  {
    name: 'PharaohSoft',
    id: 'pharaoh',
    icon: ASSETS.images.pharaoh,
    h: 35,
    w: 100,
  },
];

export const FULL_COMPANIES: Company[] = [
  {
    name: 'Alrajhi Capital',
    id: 'arc',
    icon: ASSETS.images.arc_logo,
    h: 35,
    w: 100,
    description:
      'Leading a React Native squad delivering high-scale fintech solutions for Al Rajhi Capital, one of the top trading platforms in KSA, in collaboration with Ejada as an outsourcing partner.',
    startDate: 'Apr. 2023',
    endDate: 'Present',
    title: 'Squad Tech Lead',
    achievements: [
      'Led a React Native squad delivering Al Rajhi Capital, the top trading app in KSA.',
      'Delivered multiple features and modules.',
      'Contributed on enhancing performance and stability.',
      'Coordinated with other teams to deliver features from sprint planning to production.',
      'Managed code reviews, production releases, and post-release support in a high-scale environment.',
    ],
  },
  // {
  //   name: 'Ejada',
  //   id: 'ejada',
  //   icon: ASSETS.images.ejada,
  //   h: 45,
  //   w: 100,
  //   startDate: 'Apr. 2023',
  //   endDate: 'Present',
  //   description: 'Squad Tech Lead Ejada',
  //   title: 'Squad Tech Lead',
  //   achievements: [
  //     'Led a React Native squad delivering Al Rajhi Capital, the top trading app in KSA.',
  //     'Coordinated with other teams to deliver features from sprint planning to production.',
  //     'Managed code reviews, production releases, and post-release support in a high-scale environment.',
  //   ],
  // },
  {
    name: 'Etisalat Egypt',
    id: 'etistal',
    icon: ASSETS.images.etisalat,
    h: 45,
    w: 45,
    description:
      'Senior Software Engineer contributing to large-scale telecom and media applications, including high-traffic consumer apps serving millions of users across Egypt.',
    startDate: 'Apr. 2022',
    endDate: 'Apr. 2023',
    title: 'Senior Software Engineer',
    achievements: [
      'Contributed to the full rebranding and migration of the Etisalat Music app into Twist Music, now serving over 1M+ users.',
      'Implemented many native modules',
      'Developed and optimized complex features including media playback, offline caching.',
      'Assisted in resolving critical production issues and improving overall app stability.',
      'Worked closely with designers and QA teams to ensure performance and UI/UX consistency across platforms.',
    ],
  },
  {
    name: 'PharaohSoft',
    id: 'pharaoh',
    icon: ASSETS.images.pharaoh,
    h: 35,
    w: 100,
    description:
      'Software Engineer responsible for building scalable mobile solutions and delivering end-to-end applications for startups and enterprise clients across multiple industries.',
    startDate: 'Dec. 2020',
    endDate: 'Apr. 2022',
    title: 'Software Engineer',
    achievements: [
      'Delivered multiple end-to-end mobile apps independently, including Warshatna, Rotary D2451.',
      'Built white-label mobile solutions for clients in sectors like dental inventory, event management, hiring services, and services.',
    ],
  },
  {
    name: 'Freelance',
    id: 'freelance',
    icon: ASSETS.images.freelance,
    h: 35,
    w: 100,
    description:
      'Independent React Native Developer delivering custom mobile applications, consulting services, and scalable cross-platform solutions for diverse clients worldwide.',
    startDate: 'Dec. 2018',
    endDate: 'Present',
    title: 'Software Engineer',
    achievements: [
      'Developed and delivered custom mobile applications for clients across various industries using React Native.',
    ],
  },
];
